import React, { use, useLayoutEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { openMessengerApp } from '../utils/index';
import WhatsAppIcon from '../WhatsAppIcon.png';
import SmsIcon from '../SmsIcon.png';
import { textTranslations } from './text-translations';
import { useLanguage } from "../LanguageContext";
import MemeVideos from './MemeVideos';

const Ghosted = (props) => {

  const { language } = useLanguage();

  const [showAlert, setShowAlert] = useOutletContext(false);
  
  return (
     <section className="main-body-section">
        <h1 className="lucky-font hero-title">{textTranslations("title", language)}</h1>
        <div className="boggler-hero-section">
          <div className="boggler-hero-section-inner-1">
            <img className="boggler-background" height="auto" src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/homepage_graphic.webp" alt="Boggler Hero Image" />
          </div>
          <div className="boggler-hero-section-inner-2">
            <div className="message-buttons" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
              <div>
                <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-on-phone.webp?202512041" alt="Boggler on Phone" className="boggler-on-phone-image" />
              </div>
              <div className="messaging-apps-icon-container">
                <div className="messaging-icon-outer-container messaging-icon-outer-container-sms" onClick={() => openMessengerApp("english", "sms", true)}>
                    <div className='sms-icon-container ghosted-message-buttons'>
                      <img src={SmsIcon} alt="SMS Icon" className="icon sms-button" /><br />
                    </div>
                    <span className="sms-heading" style={{textAlign: "center"}}>SMS</span>
                </div>
                <div className="messaging-icon-outer-container messaging-icon-outer-container-whatsapp" onClick={() => openMessengerApp("english", "whatsapp", true)}>
                  <div className='whatsapp-icon-container ghosted-message-buttons'>
                    <img src={WhatsAppIcon} alt="WhatsApp Icon" className="icon whatsapp-button" /><br />
                  </div>
                  <span className="whatsapp-heading" style={{textAlign: "center"}}>WhatsApp</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fellow-travelers-heading">{textTranslations("main-paragraph", language)}</h2>
        <div className="the-boggler-intro" style={{textAlign: "center"}}>
          {textTranslations("main-paragraph-2", language)}
        </div>
        <div>
          <MemeVideos />
          <hr />
        </div>
        <div style={{textAlign: "center", margin: "20px auto"}}>
          <button className="learn-more-button" onClick={() => window.open("/about", "_self")}>Learn More</button>
        </div>
      </section>
  );
}

export default Ghosted;
